// ============================================================
// VCE — Registry de REGLAS de decisión (reglas como DATOS)
// ============================================================
// El motor EVALÚA reglas; nunca codifica if/else de negocio.
// El tenant puede EXTENDER con `config.extraRules` (P4 sin forks).
// Orden = prioridad (primera coincidencia gana para cada campo).
// ============================================================
import type { DecisionRule } from '../types';

export const BASE_DECISION_RULES: DecisionRule[] = [
  // R1 — contexto miniatura: composición compacta
  {
    when: (p) => p.context === 'thumbnail',
    then: { variant: 'compact', mediaRatio: 'square', capabilities: { gallery: false } },
  },
  // R2 — sin media: placeholder (resiliencia)
  {
    when: (p) => p.mediaCount === 0,
    then: { capabilities: { placeholder: true } },
  },
  // R3 — multi-item: galería
  {
    when: (p) => p.mediaCount >= 2,
    then: { capabilities: { gallery: true } },
  },
  // R4 — video en detalle: poster + controles
  {
    when: (p) => p.hasVideo && p.context === 'detail',
    then: { capabilities: { poster: true, controls: true } },
  },
  // R5 — info pesada: la media CEDE espacio antes que sacrificar info (P3)
  {
    when: (p) => p.infoWeight === 'heavy',
    then: { mediaRatio: 'heavy', infoTreatment: 'clamped' },
  },
  // R6 — estado no activo: acciones prominentes (footer anclado)
  {
    when: (p) => p.state === 'blocked' || p.state === 'sold' || p.state === 'verifying',
    then: { actionPriority: 'prominent' },
  },
  // R7 — contexto detalle: galería + contador
  {
    when: (p) => p.context === 'detail',
    then: { capabilities: { gallery: true, counter: true } },
  },
  // R8 — regla base (catch-all): composición por defecto
  {
    when: () => true,
    then: { variant: 'default', mediaRatio: 'default', infoTreatment: 'compact', actionPriority: 'normal', fit: 'contain' },
  },
];
